import i18next from 'i18next'
import * as React from 'react'
import { Fun, IOWidget, any, async, fromJSX, nothing } from 'widgets-for-react'
import { ModalLayout } from '../../../../utils/modal'
import { CollectionEditorLayout } from './collectionEditorLayout'
import {
  CollectionEditorState,
  collectionEditorStateUpdaters,
} from './collectionEditorState'

export const collectionEditorWidget =
  (
    isNested: boolean,
    collectionId: string | undefined = undefined, // an undefined collectionId means that a new collection should be created
    initialName: string = '',
    initialDescription: string = ''
  ): IOWidget<
    CollectionEditorState,
    Fun<
      CollectionEditorState,
      CollectionEditorState & {
        hideOuterModal: boolean
        reloadCollections?: boolean
      }
    >
  > =>
  (collectionEditorState: CollectionEditorState) =>
    any([
      async(collectionEditorState.editingState).map((update) =>
        collectionEditorStateUpdaters.editingStateUpdater(isNested)(update)
      ),
      collectionEditorState.opened
        ? fromJSX((setState) => (
            <ModalLayout
              title={
                collectionId === undefined
                  ? i18next.t('collection:newCollection')
                  : i18next.t('collection:editCollection')
              }
              onHide={() =>
                setState(collectionEditorStateUpdaters.stopEditingUpdater(true))
              }
              hasForm={true}
              primaryAction={{
                kind: 'button',
                type: 'submit',
                label:
                  collectionId === undefined
                    ? i18next.t('collection:createCollection')
                    : i18next.t('common:save'),
                onClick: () =>
                  setState(
                    collectionEditorStateUpdaters.startLoadingEditingStateUpdater(
                      collectionId
                    )
                  ),

                isDisabled:
                  collectionEditorState.name === '' ||
                  (collectionId !== undefined &&
                    collectionEditorState.name === initialName &&
                    collectionEditorState.description === initialDescription),
              }}
              secondaryAction={
                isNested
                  ? {
                      kind: 'button',
                      label: i18next.t('common:cancel'),
                      onClick: () =>
                        setState(
                          collectionEditorStateUpdaters.stopEditingUpdater(
                            false
                          )
                        ),
                    }
                  : undefined
              }
            >
              {collectionEditorState.opened && (
                <CollectionEditorLayout
                  nameValue={collectionEditorState.name}
                  onNameChange={(name) =>
                    setState(
                      collectionEditorStateUpdaters.collectionNameUpdater(name)
                    )
                  }
                  descriptionValue={collectionEditorState.description}
                  onDescriptionChange={(description) =>
                    setState(
                      collectionEditorStateUpdaters.collectionDescriptionUpdater(
                        description
                      )
                    )
                  }
                />
              )}
            </ModalLayout>
          ))
        : nothing(),
    ])
